import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

export const newTicketStyles = StyleSheet.create({
	popup: {
		maxWidth: 600,
	},
	fieldRow: {
		display: 'grid',
		gridTemplateColumns: '1fr 1fr',
		gap: THEME.spacing.md,
	},
	csmRow: {
		marginTop: THEME.spacing.xs,
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
	},
	csmName: {
		color: THEME.colors.text.main,
		fontWeight: THEME.typography.fontWeights.semibold,
	},
	descriptionEditor: {
		border: `1px solid ${THEME.colors.border.main}`,
		borderRadius: THEME.common.borderRadius,
		minHeight: 110,
		maxHeight: 280,
		overflowY: 'auto' as const,
		cursor: 'text',
		':focus-within': {
			borderColor: THEME.colors.primary.main,
		},
	},
	selectTrigger: {
		width: '100%',
	},
	manualLink: {
		alignSelf: 'flex-start',
		padding: 0,
		height: 'auto',
		fontSize: THEME.typography.fontSizes.xs,
	},
	contactResults: {
		display: 'flex',
		flexDirection: 'column' as const,
		gap: 2,
		maxHeight: 216,
		overflowY: 'auto' as const,
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: THEME.common.borderRadius,
		padding: THEME.spacing.xs,
	},
	contactResult: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: THEME.spacing.sm,
		width: '100%',
		height: 'auto',
		padding: '6px 8px',
		textAlign: 'left' as const,
	},
	contactResultIdentity: {
		minWidth: 0,
		display: 'flex',
		flexDirection: 'column' as const,
	},
	contactResultName: {
		fontSize: 13,
		fontWeight: THEME.typography.fontWeights.semibold,
		color: THEME.colors.text.main,
		...THEME.common.truncate,
	},
	contactResultEmail: {
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.standard,
		color: THEME.colors.text.light,
		...THEME.common.truncate,
	},
	contactResultAccount: {
		flex: 'none',
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.standard,
		color: THEME.colors.text.light,
		maxWidth: 160,
		...THEME.common.truncate,
	},
	selectedContact: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: THEME.spacing.sm,
		border: `1px solid ${THEME.colors.border.main}`,
		borderRadius: THEME.common.borderRadius,
		padding: '6px 8px 6px 10px',
	},
	draftHint: {
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
	},
	attachRow: {
		display: 'flex',
		alignItems: 'baseline',
		gap: THEME.spacing.sm,
		marginTop: THEME.spacing.xs,
	},
	fileInput: {
		display: 'none',
	},
});
